





































































































import http from "@/axios/http-common";
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";

interface ItemObat {
  obat: Array<object>;
  sediaan: string;
  qty: string;
  signa: string;
}

@Component
export default class ObatRacikanRow extends Vue {
  public obatEntries = [];
  public obatLoading = false;
  public obatModel = null;
  public obatSearch = null;
  public rules = {
    required: (value) => !!value || "Kolom ini harus diisi",
  };
  loading = false;
  items = [];
  val = "";
  search = null;
  select = null;
  list = [{ val: null, search: null }];
  entries = [];
  signaLoading = false;
  _timerId;

  @Prop() item: ItemObat;

  @Prop() index: number;

  @Prop() color: string;

  @Ref() searchBox: HTMLInputElement;

  mounted() {
    this.$nextTick(() => {
      this.searchBox.focus();
    });
  }

  triggerSubmit() {
    this.$emit("trigger-submit");
  }

  removeItem(index) {
    this.$emit("remove-item", index);
  }

  @Watch("search", { deep: true })
  changedSearch() {
    this.entries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (
        this.search === null ||
        this.search.length < 2 ||
        this.item.signa === this.search
      )
        return;

      this.signaLoading = true;

      http
        .getDataParam("/template/signa/search", {
          params: { term: this.search },
        })
        .then((res) => {
          this.entries = res.data.map((signa) => {
            return signa.text;
          });

          if (!res.data.length) {
            this.item.signa = this.search;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.signaLoading = false));
    }, 500);
  }

  selectObat(val) {
    this.obatSearch = null;
    this.obatEntries = [];
    this.addObat(val);
  }

  @Watch("obatSearch")
  changedObatSearch() {
    this.obatEntries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.obatSearch === null || this.obatSearch.length < 3) return;

      this.obatLoading = true;

      http
        .getDataParam("/referensi/obat/search", {
          params: { term: this.obatSearch },
        })
        .then((res) => {
          this.obatEntries = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.obatLoading = false));
    }, 500);
  }

  addObat(obat) {
    this.item.obat.push({ nama: obat.nama, qty: "", satuan: obat.satuan });
  }

  removeKomponenItem(index) {
    this.item.obat.splice(index, 1);
  }
}
